import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m4.655 12.963 9.999-9.092a2 2 0 0 1 2.69 0l10.001 9.092a2 2 0 0 1 .655 1.48V26a2 2 0 0 1-2 2h-6.001a2 2 0 0 1-2-2v-6h-4v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V14.442a2 2 0 0 1 .655-1.48M15.999 5.35 6 14.442V26h6v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6h6V14.443z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconHouse = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHouse);
export default Memo;
